import React from 'react'
import { Avatar, Box } from '@mui/material';
import { Routes, Route } from "react-router-dom";
import MyToolBar from '../components/MyToolBar';
import { useSelector } from "react-redux";
import logo from './logo.png'
import logosm from './logosm.png'
import logoyw from './yellow_white_logo.png'
import { useLocation } from 'react-router-dom';
import './layout.css';
import SideBar from './SideBar';

export default function Layout(props) {
    let user = useSelector((state) => state?.loginState?.auth)
    const [toggled, setToggled] = React.useState(false);
    const [isMinimize, setIsMinimize] = React.useState(false);
    const [broken, setBroken] = React.useState(window.matchMedia('(max-width: 800px)').matches);
    const location = useLocation();
    let hideProps = props?.menus?.filter(item => item.to == location.pathname);
    hideProps = hideProps?.length > 0 ? hideProps[0] : {}

    React.useEffect(() => {
        setToggled(!broken)
    }, [])

    const makePermittedMenu = (menu, permissions) => {
        if (menu?.owner?.includes(user.main_role)) { menu.label = menu.changeText }
        if (menu?.hide) return undefined
        if (menu?.permission && !permissions.includes(menu?.permission)) return undefined
        return menu
    }
    // ispushsidebar
    const createMenu = () => {
        let routers = []
        let permissions = user.permissions.map((permission) => permission.split(".")[1])
        if (props?.info) {
            console.info("Permissions", permissions)
        }
        if (!permissions.includes('*')) { permissions.push("*") }

        return [props?.menus?.map((menu, j) => {
            routers.push(menu)
            routers.push(...menu?.submenus || [])
            let pmenu = makePermittedMenu(menu, permissions)
            if (!pmenu) return undefined
            let submenus = pmenu?.submenus?.map((submenu, i) => {
                return makePermittedMenu(submenu, permissions)
            })
            pmenu.submenus = submenus?.filter((submenu) => submenu != undefined) || []
            return pmenu
        }), routers]
    }
    const [permittedMenu, routers] = createMenu()

    const Margin = (hideBar) => {
        let body = <>
            {!hideProps.hideSideBar && <SideBar menus={permittedMenu} />}
            <Box name="main" sx={{ width: 1 }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%', /* Make the container take up the full viewport height */
                    paddingTop: hideProps.hideHeader ? '0px' : '60px'
                }}>
                    <Box sx={{ flex: '1 1 auto', borderRadius: 0 }}>
                        <Routes>
                            {routers?.map((submenu, j) => submenu && <>
                                <Route key={j} path={submenu.to} element={submenu.component} />
                                {Array.isArray(submenu.proxyto) ? submenu.proxyto.map((proxyto, k) => <Route key={k} path={proxyto?.to} element={proxyto?.component} />) : <Route key={j} path={submenu?.proxyto?.to} element={submenu?.proxyto?.component} />}
                            </>)}

                            {/* <Route path="*" element={<NoPage />} /> */}
                        </Routes>
                    </Box>
                </Box >


            </Box>
        </>

        if (hideBar) return body
        return <Box>
            <Box sx={{ flex: '0 0 auto' }}>
                {!hideProps.hideHeader && <>
                    <MyToolBar logo={logo} logosm={logosm} logoyw={logoyw} appName={props?.appName} user={user} onToggled={() => { setToggled(!toggled); setIsMinimize(!isMinimize) }} onLogout={props.onLogout} />
                </>}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'stretch' }} gap={0}>
                {body}
            </Box>
        </Box >
    }
    return (
        <>
            {Margin(hideProps.hideSideBar && hideProps.hideHeader)}
        </>
    )

}